const randomInt = (lower, upper) => lower + Math.floor(Math.random() * (upper - lower + 1));

export default randomInt;
